import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCalendarOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M22.5 7.5v15A1.5 1.5 0 0 1 21 24H3a1.5 1.5 0 0 1-1.5-1.5V3h3.75V0h1.5v3h10.5V0h1.5v3h3.75zM3 7.5h18v-3H3zm0 15h18V9H3zM18 21v-1.5h1.5V21z" /></svg>
);
